import { currentAuth } from "../auth/auth";
import { markDirty } from "../cloud/sync";

// Per-user storage. All app data (drawings, replay sessions, prefs, analysis) is keyed
// under mytv.u.<username>.* in localStorage — the fast synchronous cache — and every
// write is mirrored to the cloud (Supabase `user_kv`) by cloud/sync.
export function uKey(key: string): string {
  const a = currentAuth();
  return `mytv.u.${a ? a.username : "guest"}.${key}`;
}
export function uGet(key: string): string | null {
  try {
    return localStorage.getItem(uKey(key));
  } catch {
    return null;
  }
}
export function uSet(key: string, val: string) {
  try {
    localStorage.setItem(uKey(key), val);
  } catch {}
  markDirty(key);
}
export function uRemove(key: string) {
  try {
    localStorage.removeItem(uKey(key));
  } catch {}
  markDirty(key);
}
